import { path } from 'ramda';
import { useSportsbookStore } from '../../store';

export const selectLineField = (lineKey, field) =>
  path(['lines', lineKey, field]);

export const useLineField = (lineKey, field) =>
  useSportsbookStore(selectLineField(lineKey, field));

// static selector
export const getLineField = (lineKey, field) =>
  selectLineField(lineKey, field)(useSportsbookStore.getState());
